import { ConfigCatProvider } from 'configcat-react';
import { ComponentProps, FunctionComponent, PropsWithChildren, useEffect } from 'react';

import { AppShell } from '@climatepartner/app-shell';
import { Spinner } from '@climatepartner/components';

import { EcopilotApiClientSetup } from '../components/api-client';
import useAuth from '../hooks/useAuth';
import { useMonitor } from '../hooks/useMonitor';
import { CONFIG_CAT_SDK_KEY, ENVIRONMENT } from '../variables';
import { HeaderTitle } from './components/header';

const Layout: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const { user } = useAuth();

    const { monitor } = useMonitor();

    useEffect(() => {
        if (user) {
            monitor.setUser(user);
        }
    }, [user, monitor]);

    if (!user) {
        return <Spinner isFixed />;
    }

    return (
        <ConfigCatProvider
            sdkKey={CONFIG_CAT_SDK_KEY}
            options={{
                defaultUser: {
                    email: user.email,
                    identifier: user.id,
                    custom: { email: user.email },
                },
            }}
        >
            <EcopilotApiClientSetup>{children}</EcopilotApiClientSetup>
        </ConfigCatProvider>
    );
};

const FRONTEGG_ENVIRONMENT: Record<typeof ENVIRONMENT, ComponentProps<typeof AppShell>['fronteggEnvironment']> = {
    local: 'staging',
    staging: 'staging',
    prod: 'prod',
};

const PageLayout: FunctionComponent<PropsWithChildren> = (props) => {
    return (
        <AppShell
            fronteggEnvironment={FRONTEGG_ENVIRONMENT[ENVIRONMENT]}
            header={{ slots: { middle: <HeaderTitle /> } }}
            currentServiceId="ecopilot"
            slots={{ languagePicker: null }}
            isInternalApp
        >
            <Layout {...props} />
        </AppShell>
    );
};

export default PageLayout;
